import { partition } from 'lodash';
import moment from 'moment-timezone';
import React from 'react';

import { TimetableRule } from '../../graphql/api/generated';
import { formatEnumValue, formatTimestamp } from '../../utils';

const DAY_ABBREVIATIONS = [
  'M',
  'Tu',
  'W',
  'Th',
  'F',
  'Sa',
  'Su',
];

interface ITimetableProps {
  timetable: TimetableRule[] | null | undefined;
  appendState?: boolean;
}

export const Timetable: React.FC<ITimetableProps> = (props) => {
  const { appendState } = props;
  const timetable = props.timetable || [];

  if (!timetable?.length) {
    return null;
  }

  const [
    fixedDateSchedules,
    recurringSchedules,
  ] = partition(timetable, t => t.startDate && t.endDate);

  return (
    <>
      <div style={{ marginBottom: fixedDateSchedules.length && recurringSchedules.length ? 15 : 0 }}>
        {fixedDateSchedules.map(({ startDate, endDate, state }, index) => {
          return (
            <div key={index} style={{ whiteSpace: 'nowrap' }}>
              {formatTimestamp(startDate)}
              <span style={{ paddingLeft: 10, paddingRight: 10 }}>-</span>
              {formatTimestamp(endDate)}
              {appendState && state && (
                <span style={{ paddingLeft: 15 }}>
                  ({formatEnumValue(state)})
                </span>
              )}
            </div>
          );
        })}
      </div>
      {recurringSchedules.map(({ days, start, end, state }, index) => {
        const dayAbbreviations = days.map(day => DAY_ABBREVIATIONS[day - 1]).join(', ');

        const parsedStartTime = moment(start, 'HH:mm');
        const parsedEndTime = moment(end, 'HH:mm');

        const times = `${parsedStartTime.format('h:mma')} - ${parsedEndTime.format('h:mma')}`;

        const rowStyle: React.CSSProperties = {
          display: 'table-row',
          whiteSpace: 'nowrap',
          marginBottom: index !== timetable.length - 1 ? 10 : undefined,
        };

        const cellStyle: React.CSSProperties = { display: 'table-cell' };

        return (
          <div key={index} style={rowStyle}>
            <span style={{ ...cellStyle, paddingRight: 15 }}>
              {dayAbbreviations}:&nbsp;
            </span>
            <span style={cellStyle}>{times}</span>
            {appendState && state && (
              <span style={{ ...cellStyle, paddingLeft: 15 }}>
                ({formatEnumValue(state)})
              </span>
            )}
          </div>
        );
      })}
    </>
  );
};
